<template>
  <div class="wrap">
      <rich-text v-if="content" :content="content" :is-encrypt="is_encrypt === 1" :watermark="watermark" />
  </div>
</template>

<script>
import PdfView from "@/components/pdf-view.vue";
import RichText from "@/components/rich-text.vue";

export default {
  components: {RichText, PdfView},
  data() {
    return {
      platform: 'h5',
      content: '',
      watermark: '',
      is_encrypt: 1,
    };
  },
  mounted() {
    const option = this.$route.query;
    this.platform = option.platform || 'h5';
    this.content = option.content || this.content;
    this.watermark = option.watermark || this.watermark;
    this.is_encrypt = parseInt(option.is_encrypt || 1);
  },
  methods: {
  },
};
</script>
<style scoped>
.wrap {
  width: 100%;
}
</style>













